/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type Day = "Friday" | "Monday" | "Saturday" | "Sunday" | "Thursday" | "Tuesday" | "Wednesday" | "%future added value";
export type ExcludedSlots = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type MaxSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type MinSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type WorkingHoursTypeEnum = "Base" | "Meeting" | "PreferredFocusTime" | "%future added value";
export type OnboardingWorkingHoursStep_org = {
    readonly experiments: ReadonlyArray<string | null> | null;
    readonly userWorkingHours: {
        readonly id: string;
        readonly hasBeenSet: boolean | null;
        readonly workingHours: {
            readonly id: string;
            readonly type: WorkingHoursTypeEnum | null;
            readonly timeZone: string | null;
            readonly daySettings: ReadonlyArray<{
                readonly day: Day | null;
                readonly setting: {
                    readonly minSlot: MinSlot | null;
                    readonly maxSlot: MaxSlot | null;
                    readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
                } | null;
            } | null> | null;
            readonly dayOverrides: ReadonlyArray<{
                readonly date: string | null;
                readonly setting: {
                    readonly minSlot: MinSlot | null;
                    readonly maxSlot: MaxSlot | null;
                    readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
                } | null;
            } | null> | null;
            readonly " $fragmentRefs": FragmentRefs<"DraggableWorkingHours_workingHours">;
        } | null;
    } | null;
    readonly userMeetingHours: {
        readonly id: string;
        readonly hasBeenSet: boolean | null;
        readonly workingHours: {
            readonly id: string;
            readonly type: WorkingHoursTypeEnum | null;
            readonly timeZone: string | null;
            readonly daySettings: ReadonlyArray<{
                readonly day: Day | null;
                readonly setting: {
                    readonly minSlot: MinSlot | null;
                    readonly maxSlot: MaxSlot | null;
                    readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
                } | null;
            } | null> | null;
            readonly dayOverrides: ReadonlyArray<{
                readonly date: string | null;
                readonly setting: {
                    readonly minSlot: MinSlot | null;
                    readonly maxSlot: MaxSlot | null;
                    readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
                } | null;
            } | null> | null;
            readonly " $fragmentRefs": FragmentRefs<"DraggableWorkingHours_workingHours">;
        } | null;
    } | null;
    readonly " $refType": "OnboardingWorkingHoursStep_org";
};
export type OnboardingWorkingHoursStep_org$data = OnboardingWorkingHoursStep_org;
export type OnboardingWorkingHoursStep_org$key = {
    readonly " $data"?: OnboardingWorkingHoursStep_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OnboardingWorkingHoursStep_org">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        {
            "kind": "Literal",
            "name": "resolveOverrides",
            "value": false
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v3 = [
        (v1 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasBeenSet",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "WorkingHours",
            "kind": "LinkedField",
            "name": "workingHours",
            "plural": false,
            "selections": [
                (v1 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeZone",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DaySetting",
                    "kind": "LinkedField",
                    "name": "daySettings",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "day",
                            "storageKey": null
                        },
                        (v2 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DayOverride",
                    "kind": "LinkedField",
                    "name": "dayOverrides",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "date",
                            "storageKey": null
                        },
                        (v2 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DraggableWorkingHours_workingHours"
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "OnboardingWorkingHoursStep_org",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "experiments",
                "storageKey": null
            },
            {
                "alias": null,
                "args": (v0 /*: any*/),
                "concreteType": "UserWorkingHours",
                "kind": "LinkedField",
                "name": "userWorkingHours",
                "plural": false,
                "selections": (v3 /*: any*/),
                "storageKey": "userWorkingHours(resolveOverrides:false)"
            },
            {
                "alias": null,
                "args": (v0 /*: any*/),
                "concreteType": "UserMeetingHours",
                "kind": "LinkedField",
                "name": "userMeetingHours",
                "plural": false,
                "selections": (v3 /*: any*/),
                "storageKey": "userMeetingHours(resolveOverrides:false)"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '5a9362fac3bc5871b6b5049ad84a78ec';
export default node;
